import {
  ContactType,
  RoiSmsData,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AnalyticsUtils } from '@frontend/analytics-shared';

const pageLimit = 10;
const contactTypes: ContactType[] = [
  ContactType.EXISTING_PATIENT,
  ContactType.NEW_PATIENT,
  ContactType.UNSHEDULED_PATIENT,
];
const appointmentsTypes = ['OrthVisit', 'Post Op', 'PeriodicX, ProphyAd', 'ProphyAd'];

export const patientsDemoData = (locationIds: string[]): RoiSmsData[] => {
  // This limit is used to generate the number of patients for each location
  const locationIdLimit = Math.floor(pageLimit / locationIds.length);
  const dummyUserNames = AnalyticsUtils.demoDataUtils.generateRandomUserNames(25);

  return locationIds.reduce<RoiSmsData[]>((acc, locationId) => {
    for (let i = 0; i < locationIdLimit; i++) {
      acc.push({
        appointmentType: appointmentsTypes[i % appointmentsTypes.length],
        apptsCompletionDate: AnalyticsUtils.demoDataUtils.getRandomDateAndTime(),
        contactType: contactTypes[i % contactTypes.length],
        entryDate: AnalyticsUtils.demoDataUtils.getRandomDateAndTime(),
        locationId: locationId,
        messageDetails: 'This is a dummy message text', // Translation not needed
        patientId: AnalyticsUtils.demoDataUtils.generateRandomUUID(),
        patientName: `${dummyUserNames[AnalyticsUtils.demoDataUtils.generateRandomInt(0, 24)].firstName} ${
          dummyUserNames[AnalyticsUtils.demoDataUtils.generateRandomInt(0, 24)].lastName
        }`,
        phoneNumber: AnalyticsUtils.demoDataUtils.generateRandomNumberString(10),
        practitionerName: `${dummyUserNames[AnalyticsUtils.demoDataUtils.generateRandomInt(0, 24)].firstName} ${
          dummyUserNames[AnalyticsUtils.demoDataUtils.generateRandomInt(0, 24)].lastName
        }`,
        receiverNumber: AnalyticsUtils.demoDataUtils.generateRandomNumberString(10),
        senderNumber: AnalyticsUtils.demoDataUtils.generateRandomNumberString(10),
      });
    }

    return acc;
  }, []);
};
